<template>
  <div class="imageList">
    <div class="iheader">
      <div class="iheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1">
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="!bgFlag" />
          <img src="~@/assets/images/svg/logo_top_white.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
      <div class="herg">
        <span class="herg_lang"
              @click='changeLang()'>{{lang}}</span>
        <i class="herg_mu"
           @click="nuneClick(1)"></i>
      </div>
    </div>
    <div class="bread">
      <div class="bread_lf">
        <span class="bread_nu">全部文章</span>
        <i class="sel_ico"></i>
      </div>
      <div class="bread_rg">
        <i class="rgmu"></i>
      </div>
    </div>
    <div class="jorWcon">
      <div class="jorWcon_li clearfix">
        <span class="ztfx">专题分享</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic1.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">山中湖与水神殿</p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
      <div class="jorWcon_li clearfix">
        <span class="ztfx">专题分享</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic2.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">玻璃在建筑空间的运用</p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
      <div class="jorWcon_li clearfix">
        <span class="ztfx">人物介绍</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic3.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">伯纳德· 屈米设计作品解读</p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
      <div class="jorWcon_li clearfix">
        <span class="ztfx">新讯</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic4.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">2020 IDAF首届
            上海创新设计建筑论坛
          </p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
      <div class="jorWcon_li clearfix">
        <span class="ztfx">探索发现</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic5.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题</p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
      <div class="jorWcon_li clearfix">
        <span class="ztfx">专题分享</span>
        <div class="jorWcon_lf">
          <img src="~@/assets/images/rizhi/xx_pic6.jpg"
               class="wz_pic" />
        </div>
        <div class="jorWcon_rg">
          <p class="jorWcon_rg_p1">这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题这里是标题</p>
          <p class="jorWcon_rg_p2">2022/01/12</p>
        </div>
      </div>
    </div>

    <!-- footer -->
    <!-- footer -->
    <foot @contact="contact"></foot>
    <transition name="slide-fade">
      <munePage v-show="muneFlag"
                :muneFlag="muneFlag"
                :muneIndex="muneIndex"
                @closeMu="closeMu"
                @muneChange='muneIndexChange'></munePage>
    </transition>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      bgFlag: false,
      muneFlag: false,
      muneIndex: 2,
      mySwiper: null,
    }
  },
  components: { foot, gotop, munePage },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  methods: {
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 2
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/journalList2.vue